import { ObservableMap } from "mobx";

import { Client } from "../Client";

/**
 * @deprecated
 * Все что от этого класса наследуется должно быть от этого наследования избавлено просто добавлением свойства map
 * в качестве примера можно посмотреть класс Users
 */
export default class Collection<K, V> extends ObservableMap<K, V> {
    client: Client;

    constructor(client: Client) {
        super();
        this.client = client;
    }
}
